<template>
  <div v-if="$store.state.user" class="h-full">
    <Header
      :nav-collapse="navCollapse"
      @changeNavCollapse="changeNavCollapse"
    />
    <el-container class="home flex">
      <el-aside class="aside" width="180">
        <Menu :nav-collapse="navCollapse" />
      </el-aside>
      <el-main class="bg-gray-100 main">
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>
<script>
import Header from './PageHeader.vue'
import Menu from './PageMenu.vue'
import api from '@/api'
import * as Sentry from '@sentry/browser'

export default {
  name: 'Home',
  components: {
    Header,
    Menu,
  },
  data() {
    return {
      navCollapse: false,
    }
  },
  mounted() {
    api.profile().then(res => {
      this.$store.state.user = res.data
      const user = res.data
      Sentry.setUser({
        mobile: user.mobile,
        name: user.name,
        id: user.id.toString(),
      })
    })
  },
  methods: {
    changeNavCollapse() {
      this.navCollapse = !this.navCollapse
    },
  },
}
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
}
.main {
  margin-top: 60px;
  min-height: calc(100vh - 60px);
  margin-left: 180px;
}
.aside {
  margin-top: 60px;
  bottom: 0;
  top: 0;
  position: fixed;
}
</style>
